export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileLezartProblemak');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileLezartProblemak');
    }
}
